// Module
var code = `<div data-bind="css: question.cssClasses.root, event: { keydown: question.koOnKeyDown }">
  <label data-bind="css: question.getSwatchCss(), style: question.getSwatchStyle()">
    <!-- ko component: { name: 'sv-svg-icon', params: { iconName: question.cssClasses.swatchIcon, size: 'auto' } } --><!-- /ko -->
    <input type="color" data-bind="disable: question.isInputReadOnly, css: question.cssClasses.colorInput, value: question.renderedColorValue, event: { change: question.koOnColorInputChange }" tabindex="-1">
  </label>
  <input autocomplete="off" data-bind="disable: question.isInputReadOnly, attr: { id: question.inputId, placeholder: question.renderedPlaceholder, 'aria-required': question.ariaRequired, 'aria-label': question.ariaLabel, 'aria-invalid': question.ariaInvalid, 'aria-describedby': question.ariaDescribedBy }, 
    event: { change: question.koOnChange, blur: question.koOnBlur, keyup: question.koOnKeyUp, beforeinput: question.koOnBeforeInput },
    value: question.renderedValue,
    css: question.cssClasses.control">
  <!-- ko if: question.showDropdownAction -->
  <!-- ko component: { name: 'sv-action-bar-item', params: { item: question.koDropdownAction() } } --><!-- /ko -->
  <sv-popup params="model: question.dropdownAction.popupModel"></sv-popup>
  <!-- /ko -->
</div>`;
// Exports
export default code;